import {salesDemoConstants} from "../../../../constants/General/salesDemo.constants";

const initialState = {
    canStart: false,
    listFetching: false,
    runs: [],
    startFetching: false,
    startError: false,
    statusError: false,
    run: null,
    searchQuery: '',
    searchFetching: false,
    searchResults: [],
    searchError: false,
};

// Ayni kosu listede de varsa son durumuyla guncellensin
const mergeRun = (runs, run) => {
    if (!run || !run.run_id) {
        return runs;
    }
    const exists = runs.some(item => item.run_id === run.run_id);
    return exists
        ? runs.map(item => item.run_id === run.run_id ? {...item, ...run} : item)
        : [run, ...runs];
};

export default function (state = initialState, action) {
    switch (action.type) {

        case salesDemoConstants.SALES_DEMO_CHECK_PENDING:
            return state;
        case salesDemoConstants.SALES_DEMO_CHECK_FULFILLED:
            return {
                ...state,
                canStart: !!(action.payload && action.payload.data && action.payload.data.can_start === true),
            };
        case salesDemoConstants.SALES_DEMO_CHECK_REJECTED:
            return {
                ...state,
                canStart: false,
            };

        case salesDemoConstants.SALES_DEMO_LIST_PENDING:
            return {
                ...state,
                listFetching: true,
            };
        case salesDemoConstants.SALES_DEMO_LIST_FULFILLED:
            return {
                ...state,
                listFetching: false,
                runs: (action.payload && action.payload.data && Array.isArray(action.payload.data.runs))
                    ? action.payload.data.runs
                    : [],
            };
        case salesDemoConstants.SALES_DEMO_LIST_REJECTED:
            return {
                ...state,
                listFetching: false,
            };

        case salesDemoConstants.SALES_DEMO_START_PENDING:
            return {
                ...state,
                startFetching: true,
                startError: false,
                statusError: false,
            };
        case salesDemoConstants.SALES_DEMO_START_FULFILLED:
            return {
                ...state,
                startFetching: false,
                run: action.payload && action.payload.data,
                runs: mergeRun(state.runs, action.payload && action.payload.data),
            };
        case salesDemoConstants.SALES_DEMO_START_REJECTED:
            return {
                ...state,
                startFetching: false,
                startError: action.payload,
            };

        case salesDemoConstants.SALES_DEMO_STATUS_PENDING:
            return state;
        case salesDemoConstants.SALES_DEMO_STATUS_FULFILLED:
            return {
                ...state,
                statusError: false,
                run: action.payload && action.payload.data,
                runs: mergeRun(state.runs, action.payload && action.payload.data),
            };
        case salesDemoConstants.SALES_DEMO_STATUS_REJECTED:
            return {
                ...state,
                statusError: action.payload,
            };

        case salesDemoConstants.SALES_DEMO_SEARCH_PENDING:
            return {
                ...state,
                searchQuery: action.meta && action.meta.query,
                searchFetching: true,
                searchError: false,
            };
        case salesDemoConstants.SALES_DEMO_SEARCH_FULFILLED:
            if (!action.meta || action.meta.query !== state.searchQuery) {
                return state;
            }
            return {
                ...state,
                searchFetching: false,
                searchResults: (action.payload && Array.isArray(action.payload.data)) ? action.payload.data : [],
            };
        case salesDemoConstants.SALES_DEMO_SEARCH_REJECTED:
            if (!action.meta || action.meta.query !== state.searchQuery) {
                return state;
            }
            return {
                ...state,
                searchFetching: false,
                searchResults: [],
                searchError: action.payload,
            };
        case salesDemoConstants.SALES_DEMO_SEARCH_CLEAR:
            return {
                ...state,
                searchQuery: '',
                searchFetching: false,
                searchResults: [],
                searchError: false,
            };

        case salesDemoConstants.SALES_DEMO_CLEAR:
            return {
                ...state,
                startError: false,
                statusError: false,
                run: null,
            };

        default:
            return state;
    }
}
